import React, { Component } from 'react';

class From extends Component {
    state = { value: "" }

    handleChange = (event) => {
        this.setState({value: event.target.value});
    }

    handleSubmit = (e) => {
        console.log('working!!!')
        e.preventDefault();
        this.props.getRecipe(this.state.value);
        this.setState({value: ""})
    }
    
    render() { 

        return ( 
            <form onSubmit={this.handleSubmit} className="input-group mb-3 mx-auto" style={{width: "60%"}}>
                <input onChange={this.handleChange} value={this.state.value} type="text" className="form-control shadow-none" placeholder="Search Recipes...eg. pasta" aria-label="Recipient's username" aria-describedby="button-addon2" />
                <div className="input-group-append">
                    <button className="btn btn-outline-danger shadow-none" type="submit">Search</button>
                </div>
            </form>
        );
    }
}
 
export default From;
